import { Button } from "@/ui-components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/util-components/dropdown-menu";
import { Table } from "@tanstack/react-table";
import { Columns3 } from "lucide-react";

export interface DataTable2ColumnsProps<TData> {
  table: Table<TData>;
  label?: string;
  getColumnLabel?: (columnId: string) => string;
}

export function DataTable2Columns<TData>({ table, label = "Spalten", getColumnLabel }: DataTable2ColumnsProps<TData>) {
  const hideableColumns = table
    .getAllLeafColumns()
    .filter((column) => column.getCanHide())
    .filter((column) => column.columnDef.enableHiding !== false);

  if (!hideableColumns.length) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-10 rounded-xl bg-white border-gray-200 hover:bg-gray-50"
        >
          <Columns3 className="h-4 w-4 mr-2 text-gray-500" />
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Spalten</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {hideableColumns.map((column) => {
          const metaLabel = (column.columnDef.meta as any)?.label as string | undefined;
          const resolvedLabel = getColumnLabel?.(column.id) ?? metaLabel ?? column.id;

          return (
            <DropdownMenuCheckboxItem
              key={column.id}
              checked={column.getIsVisible()}
              onCheckedChange={(checked) => column.toggleVisibility(Boolean(checked))}
            >
              {resolvedLabel}
            </DropdownMenuCheckboxItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

